module.exports = __webpack_public_path__ + "img/2e5fd8687881f8070ac5fb36c5e76698.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_08.png
// module id = 65
// module chunks = 0